module.exports = __webpack_public_path__ + "img/mic1.703d66c3.jpg";